export const SEGMENTS_ARIAL_LABEL = {
    TAG_INPUT_SELECT_ARIAL_LABEL: 'tag-input-select-arial-label',
};
export const TAG_CAMPAIGN_TEXTS = {
    tagsPlaceHolder: 'Edit here...',
};

export const SEGMENTS_MODAL_TEST_ID = {
    TAG_SELECT: 'campaign-group-tags-modal-tag-select',
    TAG_CAMPAIGN_SELECTOR_TESTID: 'creatable-select-component',
    TAG_INPUT_SELECT_TESTID: 'tag-input-select-testid',
};
